import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { DattaConfig} from '../app-config';
import { Dscauhoi } from 'src/app/model/quanlythongtin/dscauhoi';
import {DscauhoiTraloi} from 'src/app/model/quanlythongtin/dscautraloi';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class QlttCauhoithamdoService {
  public dattaConfig: any;
  token: string;

  httpOptions: any;

  constructor(private httpClient: HttpClient) {
    this.dattaConfig = DattaConfig.config;  
  }

  ngOnInit(): void {   
  }


  //dscauhoi

  search(id: number, sort: boolean, ...field: any){
    let pars = {
      params: {
        tungay: field[0] === undefined || field[0] === null ? '' : field[0],        
        denngay: field[1] === undefined || field[1] === null ? '' : field[1],        
        chuyendeid: field[2] === undefined || field[2] === null ? '' : field[2],        
        sort: sort ? 'asc' : 'desc'
      }
    };
    return this.httpClient.get<Dscauhoi[]>(this.dattaConfig['httplink'] + `/dscauhoi/search/${id}`, pars);
  }

  export(id: number, sort: boolean, type: string, ...field: any) {
    return this.httpClient.get(this.dattaConfig['httplink'] + `/dscauhoi/export/${id}/${type}`, {
      params: {
        tungay: field[0] === undefined || field[0] === null ? '' : field[0],        
        denngay: field[1] === undefined || field[1] === null ? '' : field[1],        
        chuyendeid: field[2] === undefined || field[2] === null ? '' : field[2],        
        sort: sort ? 'asc' : 'desc'
      },
      observe: 'response',
      responseType: 'blob'
    });  
  }

  /*
  congkhaingansachexport(madv: string, type: string, exporttype: string, sort: boolean, ...field: any) {
    return this.httpClient.get(this.dattaConfig['httplink'] + `/layout/congkhaingansachexport/${madv}/${type}/${exporttype}`, {
      params: {
        soqd: field[0] === undefined ? '' : field[0],
        kyhieu: field[1] === undefined ? '' : field[1],
        searchtungay: field[2] === undefined ? '' : field[2],
        searchdenngay: field[3] === undefined ? '' : field[3],
        nam: field[4] === undefined ? '' : field[4],
        tenbaocao: field[5] === undefined ? '' : field[5],
        sort: sort ? 'asc' : 'desc'
      },
      observe: 'response',
      responseType: 'blob'
    });
  }

  */


  getDscauhoi() {    
    return this.httpClient.get<Dscauhoi[]>(this.dattaConfig['httplink'] + '/dscauhoi');
  }

  getDscauhoitheodonvi(id) {    
    return this.httpClient.get<Dscauhoi[]>(this.dattaConfig['httplink'] + '/dscauhoi/findbyunit/'+id);
  }

  
  getCauhoi(id) {
    return this.httpClient.get<Dscauhoi>(this.dattaConfig['httplink'] + '/dscauhoi/get/' +id);
  }
  addDscauhoi(newDsCH: Dscauhoi) {
     
    return this.httpClient.post<Dscauhoi>(this.dattaConfig['httplink'] + '/dscauhoi/add' , newDsCH);
  }
  deleteDscauhoi(id) {
    return this.httpClient.delete<Dscauhoi>(this.dattaConfig['httplink'] + '/dscauhoi/' + id);
  }

  updateDscauhoi(updatedDsCH: Dscauhoi) {
    return this.httpClient.put<Dscauhoi>(this.dattaConfig['httplink'] + '/dscauhoi/update', updatedDsCH);
  }

  //dscauhoitraloi
  getDscautraloi(id) {
    
    return this.httpClient.get<DscauhoiTraloi[]>(this.dattaConfig['httplink'] + '/dscauhoi/gettraloi/' + id);
  }
  addDscautraloi(newDsCTL: DscauhoiTraloi) {
     
    return this.httpClient.post<DscauhoiTraloi>(this.dattaConfig['httplink'] + '/dscauhoi/addcautraloi' , newDsCTL);
  }
  deleteDscautraloi(id) {
    return this.httpClient.delete<DscauhoiTraloi>(this.dattaConfig['httplink'] + '/dscauhoi/delcautraloi/' + id);
  }

  updateDscautraloi(updatedDsCTL: DscauhoiTraloi) {
    return this.httpClient.put<DscauhoiTraloi>(this.dattaConfig['httplink'] + '/dscauhoi/updatecautraloi', updatedDsCTL);
  }


}
